import React from "react";
import Badge from "../badge/Badge";
import PillButton from "../pillButton/PillButton";
import { DateFormatter, getDayInGerman } from "../../utils/DataFormatter";
import { formatCurrencySpacing, reverseWords } from "../../utils/Utils";

const RowData = ({
  dateString,
  sTime,
  eTime,
}: {
  dateString: any;
  sTime: any;
  eTime: any;
}) => {
  const dateParts = dateString?.split(" ");
  return (
    <div className="flex max-sm:justify-between">
      <span className="flex">
        <img
          src={"/assets/icons/calendar.svg"}
          alt="Calendar"
          className="size-5 font-light"
        />
        <p className="ml-2">
          {dateInGerman[dateParts[0] as keyof typeof dateInGerman]},{" "}
          {dateParts[1]}
        </p>
      </span>
      <span className="flex items-center">
        <img
          src={"/assets/icons/clock.svg"}
          alt="Clock"
          className="size-5 ml-8"
        />
        <p className="ml-2 font-content">{sTime}</p>
        <span className="ml-2 font-content">-</span>
        <p className="ml-2 font-content">{eTime}</p>
      </span>
    </div>
  );
};

const dateInGerman = {
  Monday: "Montag",
  Tuesday: "Dienstag",
  Wednesday: "Mittwoch",
  Thursday: "Donnerstag",
  Friday: "Freitag",
  Saturday: "Samstag",
  Sunday: "Sonntag",
};

const monthInGerman = {
  January: "Januar",
  February: "Februar",
  March: "März",
  April: "April",
  May: "Mai",
  June: "Juni",
  July: "Juli",
  August: "August",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "Dezember",
};

const Card = ({
  courseType = "vku",
  showModal,
  data,
}: {
  courseType: "plus" | "vku" | null;
  showModal: (data: any) => void;
  data: any;
}) => {
  const disabled = data?.availablePlaces === 0;
  const firstDate = DateFormatter(data?.fDate);
  const secondDate = DateFormatter(data?.sDate);
  const thirdDate = data?.tDate && DateFormatter(data?.tDate);
  const month = firstDate?.split(" ")[2];
  const year = firstDate?.split(" ")[3];
  const badgeText = courseType === "plus" ? "+" : "VKU";
  return (
    <div
      className={` bg-[#F7F7F7] rounded-[20px] p-4 flex justify-between items-center ${
        disabled && "opacity-80"
      }`}
    >
      <div className="w-full">
        <div className="w-full flex justify-between items-start">
          <h3
            className={`flex justify-start items-start gap-4 font-bold font-title ${
              disabled ? "text-gray-600" : "text-dark-blue"
            }`}
          >
            <Badge
              text={badgeText}
              disabled={disabled}
              className={`${
                courseType === "plus"
                  ? "bg-red-600 !text-2xl !h-6 flex justify-center items-center !pt-2"
                  : "bg-light-blue  !h-6 flex justify-center items-center !pt-2"
              }`}
            />
            <p className="text-2xl -mt-0.5">
              {monthInGerman[month as keyof typeof monthInGerman]} {year}
            </p>
          </h3>
          {data?.extraDescription && (
            <div className="max-w-[60%] sm:max-w-[70%] md:max-w-[80%] font-sans flex items-center">
              <p className="text-dark-blue pr-1">&#x1F6C8;</p>
              <p
                className=" text-gray-600  truncate"
                title={data?.extraDescription}
              >
                {data?.extraDescription}
              </p>
            </div>
          )}
        </div>

        <div
          className={`font-title ${
            disabled ? "text-gray-600" : "text-dark-blue"
          }`}
        >
          <div className="w-full flex justify-between items-center max-sm:flex-col">
            <div className="flex flex-col gap-1 mt-6 max-sm:float-start w-full">
              <RowData
                dateString={firstDate}
                sTime={data?.fStartTime}
                eTime={data?.fEndTime}
              />
              <RowData
                dateString={secondDate}
                sTime={data?.sStartTime}
                eTime={data?.sEndTime}
              />
              {data?.tDate && (
                <RowData
                  dateString={thirdDate}
                  sTime={data?.tStartTime}
                  eTime={data?.tEndTime}
                />
              )}
            </div>
            <div className="text-center flex items-end flex-col justify-end max-sm:flex-row max-sm:justify-between  max-sm:items-center max-sm:mt-4 max-sm:w-full">
              <p className="font-bold text-2xl">
                {reverseWords(formatCurrencySpacing(data?.price))}
              </p>
              <button
                onClick={() => showModal(data)}
                className="mt-2"
                disabled={disabled}
              >
                <PillButton
                  text={!disabled ? "Registrieren" : "Fully booked"}
                  className={`px-8 whitespace-nowrap ${
                    disabled && "!bg-gray-600 cursor-default"
                  } `}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
